export class PaymentManagementCollections {
  static ModuleName = 'payment-management';

  static PaymentConfigurations = `${PaymentManagementCollections.ModuleName}/payment-configurations`;
  static paymentConfiguration(paymentConfigurationId: string) {
    return `${PaymentManagementCollections.PaymentConfigurations}/${paymentConfigurationId}`;
  }

  static hyperpayConfigurations = `${PaymentManagementCollections.PaymentConfigurations}/hyperpay`;
  static hyperpayConfiguration(paymentConfigurationId: string) {
    return `${PaymentManagementCollections.hyperpayConfigurations}/${paymentConfigurationId}`;
  }

  static Payments = `${PaymentManagementCollections.ModuleName}/payments`;
  static payment(paymentId: string) {
    return `${PaymentManagementCollections.Payments}/${paymentId}`;
  }

  static paymentLookups() {
    return `${PaymentManagementCollections.Payments}/lookups`;
  }

  static paymentPaymentRequest(paymentId: string) {
    return `${PaymentManagementCollections.Payments}/${paymentId}/payment-request`;
  }

  static PaymentRequests = `${PaymentManagementCollections.ModuleName}/payment-requests`;
  static paymentRequest(paymentRequestId: string) {
    return `${PaymentManagementCollections.PaymentRequests}/${paymentRequestId}`;
  }

  static PaymentWebhooks = `${PaymentManagementCollections.ModuleName}/payment-webhooks`;
  static paymentWebhookStatus() {
    return `${PaymentManagementCollections.PaymentWebhooks}/status`;
  }
}
